<template>
  <div class="navbar">
    <div class="navbar-left">
      <button class="menu-trigger" type="button">
        <hamburger :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
      </button>
      <breadcrumb></breadcrumb>
    </div>

    <div class="navbar-right">
      <div class="quickbooks-link" v-if="isLogin" @click.stop="connectToQuickBooksWay()">
        <svg-icon icon-class="fi-br-link-alt"></svg-icon>
        <span>{{ $t('system.connectQuickBooks') }}</span>
      </div>

      <div class="icon-action" v-if="isLogin" @click.stop="goMessageIm('2')">
        <el-badge
          class="nav-action-badge"
          :class="{ 'has-count': systemUnReadNumber }"
          :value="systemUnReadNumber || null"
          :max="99"
        >
          <i class="fi-sr-bell"></i>
          <span class="icon-text">{{ $t('im.messageNotifications') }}</span>
        </el-badge>
      </div>

      <div class="icon-action" v-if="isLogin" @click.stop="goNewWindow()">
        <el-badge
          class="nav-action-badge"
          :class="{ 'has-count': unReadCount }"
          :value="unReadCount || null"
          :max="99"
        >
          <i class="fi-sr-headset"></i>
          <span class="icon-text">{{ $t('system.customerService') }}</span>
        </el-badge>
      </div>

      <div class="lang-switch">
        <Internationalization :fontColor="'#7C94B0'"></Internationalization>
      </div>

      <el-dropdown trigger="click">
        <div class="user-entry">
          <div class="user-icon">
            <el-badge :value="phone ? null : 1">
              <svg-icon icon-class="admin"></svg-icon>
            </el-badge>
          </div>
          <span class="user-name">{{ name }}</span>
          <i class="el-icon-arrow-down"></i>
        </div>
        <el-dropdown-menu class="user-dropdown" slot="dropdown">
          <router-link class="inlineBlock" to="/">
            <el-dropdown-item>
              {{ $t('system.home') }}
            </el-dropdown-item>
          </router-link>
          <router-link class="inlineBlock" to="/profile">
            <el-dropdown-item>
              <el-badge :value="phone ? null : 1">
                {{ $t('system.myAccount') }}
              </el-badge>
            </el-dropdown-item>
          </router-link>
          <el-dropdown-item divided>
            <span @click="logout" style="display:block;">{{ $t('system.signOut') }}</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import Hamburger from '@/components/Hamburger'
import Breadcrumb from '@/components/Breadcrumb'
import Internationalization from "@/components/Internationalization/index.vue";
import {platformUserSelectList} from "@/api/login.js"
import {getToken} from "@/utils/auth.js"
import { connectToQuickBooks } from "@/api/order";

export default {
  components: {
    Hamburger,
    Breadcrumb,
    Internationalization,
  },
  data() {
    return {
      unReadCount: 0,
      systemUnReadNumber: 0,
      customerIds: [],
      isLogin: false,
      isFirst: false,
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'name',
      'userId'
    ]),
    ...mapState({
      phone: state => state.user.phone,
    })
  },
  watch: {
    $route(to, from) {
      this.getContactList();
    }
  },
  created() {
    this.getCustomerList()
    // 检查 QuickBooks 回调
    this.callbackLoading()
    let that = this;
    this.$store.dispatch('getImInfo').then(res => {
      // 登录环信
      setTimeout(() => {
        that.getContactList();
      }, 300)
    })
    this.$eventBus.$on('im-get-num', (msg) => {
      setTimeout(() => {
        that.getContactList();
      }, 200)
    })
    this.isLogin = !!getToken()
  },
  beforeDestroy() {
    // this.$eventBus.$off('im-get-num')
  },
  methods: {
    goHome() {
      this.$router.push('/home')
    },
    goMessageIm(imType) {
      // const route = this.$router.resolve({
      //   path: "/notifications",
      //   query: {
      //     imType,
      //     hurixUnReadNum: this.systemUnReadNumber
      //   }
      // })
      // window.open(route.href, '_blank');
      this.$router.push({
        path: "/notifications",
        query: {
          imType,
          hurixUnReadNum: this.systemUnReadNumber
        }
      })
      if (imType === '2') {
        this.systemUnReadNumber = 0;
      }
    },
    async getCustomerList() {
      let {data} = await platformUserSelectList({
        roleName: '客服', status: 1, delFlag: 1
      })
      this.customerIds = data.map(e => e.id)
    },
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    logout() {
      this.$confirm(this.$t('system.sureLogout'), this.$t('message.information'), {
        confirmButtonText: this.$t('button.confirm'),
        cancelButtonText: this.$t('button.cancel'),
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('LogOut').then(() => {
          // 退出登录后通过路由跳转，避免整页刷新。
          if (this.$route.path !== '/login') {
            this.$router.replace('/login').catch(() => {})
          }
        })
      }).catch(() => {
        return false
      })
    },
    goNewWindow(shelfId = undefined, nickname = undefined) {
      if (!this.customerIds.includes(this.userId)) {
        this.$message.warning(this.$t('system.areNotCustomerService'));
        return
      }
      const routeData = this.$router.resolve({
        path: '/IM',
        query: {
          shelfId
        }
      });
      // 在新窗口中打开页面
      window.open(routeData.href, '_blank');
    },
    getContactList() {
      this.$webIM.conn.getServerConversations({pageSize: 500, cursor: ''}).then(async (res) => {
        let data = res.data;
        let contactArr = data.conversations && Array.isArray(data.conversations) ? data.conversations : [];
        let allContactList = contactArr.filter(item => item.conversationType === "groupChat");
        let emailList = contactArr.find(item => item.conversationId === "hurix")
        this.updateUnReadNum(allContactList)
        this.systemUnReadNum(emailList)
      }).catch(async err => {
        if(this.isFirst) {
          this.isFirst = false
          await this.$store.dispatch('getImInfo');
          setTimeout(() => {
            this.getContactList()
          }, 500)
        }
      })
    },
    updateUnReadNum(contactArr) {
      if (Array.isArray(contactArr) && contactArr.length > 0) {
        this.unReadCount = contactArr.reduce((accumulator, currentItem) => accumulator + currentItem.unReadCount, 0) || 0;
      } else {
        this.unReadCount = 0;
      }
    },
    systemUnReadNum(obj) {
      this.systemUnReadNumber = obj ? obj.unReadCount : 0;
      if (this.$route.query.imType === '2') {
        this.systemUnReadNumber = 0;
      }
      if (this.systemUnReadNumber) {
        this.$store.dispatch('updateUnreadCount', this.systemUnReadNumber)
        const notification = this.$notify({
          title: this.$t("message.information"),
          message: this.$t('system.unreadSystemNotifications'),
          duration: 5000,
          position: 'bottom-right',
          offset: 5,
          type: 'primary',
          iconClass: 'el-icon-info',
          customClass: 'my-custom-notification',
          onClick: () => {
            this.goMessageIm('2')
            notification.close()
          }
        });
      }
    },
    connectToQuickBooksWay() {
      connectToQuickBooks().then(res => {
        if (res.code === 200) {
          window.location.href = res.data
        }
        else {
          this.$message({
            message: res.message,
            type: 'error',
            duration: 1000
          })
        }
      })
    },
    callbackLoading() {
      const { status, message } = this.$route.query
      if ( !status || !message) return
      this.$message({
        message: message,
        type: status ? 'success' : 'error',
        duration: 1000
      })
    }
  }
}
</script>

<style lang="scss">
// 站内信提示通知
.el-notification {
  &.my-custom-notification {
    width: 340px;
    cursor: pointer;

    .el-notification__content {
      color: #606266;
      font-size: 16px;
      text-align: left;
    }

    .el-notification__title {
      font-weight: bold;
      color: #333;
    }
  }
}
</style>
<style rel="stylesheet/scss" lang="scss" scoped>
/deep/ .el-badge__content {
  top: 1px !important;
  right: 0 !important;
  border: 2px solid #ffffff;
}

.navbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: max-content;
  min-height: 64px;
  padding: 0 24px;
  box-sizing: border-box;
  background: #ffffff;
  border-bottom: 1px solid #e8ecf1;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05);

  .navbar-left {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: max-content;
    flex-shrink: 0;

    .menu-trigger {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 34px;
      height: 34px;
      padding: 0;
      border: none;
      border-radius: 8px;
      background: transparent;
      color: #7C94B0;
      cursor: pointer;
      transition: all 0.15s ease;

      &:hover {
        color: #f97316;
        background: rgba(249, 115, 22, 0.08);
      }
    }

    .page-title {
      margin: 0;
      color: #1E293B;
      font-size: 18px;
      font-weight: 600;
      line-height: 1.3;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .navbar-right {
    display: flex;
    align-items: center;
    gap: 20px;
    flex-shrink: 0;

    .svg-icon {
      font-size: 16px;
    }
  }

  .quickbooks-link,
  .icon-action,
  .lang-switch {
    color: #7C94B0;
    font-family: inherit;
    font-weight: 400;
  }

  .quickbooks-link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    cursor: pointer;
    transition: color 0.15s ease;

    &:hover {
      color: #f97316;
    }
  }

  .icon-action {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 28px;
    cursor: pointer;
    text-align: center;
    transition: color 0.15s ease;

    .nav-action-badge {
      display: inline-flex;
      align-items: center;

      &.has-count {
        padding-right: 15px;
      }

      /deep/ .el-badge__content.is-fixed {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        right: 15px !important;
        min-width: 20px;
        height: 20px;
        line-height: 1 !important;
        padding: 0 5px;
        box-sizing: border-box;
        white-space: nowrap;
      }
    }

    .icon-text{
      font-size: 14px;
      padding-left: 2px;
    }
    i{
      vertical-align: -0.18em;
    }
    &:hover {
      color: #f97316;
    }
  }

  .user-entry {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding-left: 16px;
    border-left: 1px solid #e8ecf1;
    color: #1E293B;
    cursor: pointer;

    .user-icon {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 28px;
      height: 28px;
      border-radius: 50%;
      background: rgba(249, 115, 22, 0.15);
      color: #f97316;
    }

    .user-name {
      font-size: 14px;
      font-weight: 400;
      line-height: 1;
    }

    .el-icon-arrow-down {
      color: #94a3b8;
      font-size: 12px;
      line-height: 1;
    }
  }

  @media screen and (max-width: 1200px) {
    padding: 0 18px;

    .quickbooks-link span,
    .lang-switch /deep/ .el-dropdown-link span {
      display: none;
    }
  }

  @media screen and (max-width: 768px) {
    min-height: 56px;
    padding: 0 14px;

    .navbar-right {
      gap: 14px;
    }

    .user-name {
      display: none;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue